import React, { Fragment, useState, useEffect } from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import { GENERAL } from "../../../api/general"
import { useQuery } from "react-query"
import { data } from "common/data/states"
import errorImg from "assets/images/error-img.png"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Swal from "sweetalert2"

//i18n
import { withTranslation } from "react-i18next"
import ViewApprovedAgentsByLga from "pages/Agents/ViewApprovedAgentsByLga"
import { ROLES, getUserRole, getAuthUser } from "constants/roles"

const ApprovedAgentRegistrations = props => {
  const [userRole, setUserRole] = useState(getUserRole())
  const authUser = getAuthUser() || {}
  const navigate = useNavigate()
  const [isErr, setIsErr] = useState(false)
  const [records, setRecords] = useState([])

  // State Admin / State ALGON Chairman are scoped to their own assigned state
  const redirectsToLgaBreakdown =
    userRole === ROLES.STATE_ADMIN || userRole === ROLES.STATE_ALGON_CHAIRMAN
  const redirectsToOwnLga =
    userRole === ROLES.LGA_FOCAL_PERSON || userRole === ROLES.LGA_CHAIRMAN
  const willRedirectToLgaBreakdown = redirectsToLgaBreakdown && !!authUser.state
  const willRedirectToOwnLga = redirectsToOwnLga && !!authUser.lga

  const [search, setSearch] = useState("")
  const visibleRecords = (
    redirectsToLgaBreakdown
      ? records.filter(item => String(item.id) === String(authUser.state))
      : records
  ).filter(item => item.name.toLowerCase().includes(search.toLowerCase()))

  useEffect(() => {
    if (willRedirectToLgaBreakdown) {
      navigate(
        `/approved-agent-registrations-by-lga/${
          authUser.state
        }/${encodeURIComponent(authUser.stateName || "")}`,
        { replace: true }
      )
    } else if (willRedirectToOwnLga) {
      navigate(`/view-approved-agent-registrations-by-lga/${authUser.lga}`, {
        replace: true,
      })
    }
  }, [])

  useEffect(() => {
    if (willRedirectToLgaBreakdown || willRedirectToOwnLga) return
    Swal.fire({
      title: "Fetching records...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(Swal.getDenyButton())
      },
    })
    getApprovedAgents
  }, [])

  const getApprovedAgents = useQuery({
    queryKey: ["getDataPlans"],
    queryFn: () => {
      return GENERAL.getApprovedAgents()
    },
    onSuccess: async res => {
      Swal.close()
      if (res?.palliative) {
        setIsErr(false)
        setRecords(
          res?.palliative?.sort((a, b) => a.name.localeCompare(b.name))
        )
      }
      if (res.status === 500) {
        setIsErr(true)
      }
    },
  })

  function getItemByName(arr, name) {
    return arr.find(item => String(item.name).toLowerCase() === name)?.logo
  }

  //meta title
  document.title = "Ward Registrars Management System"
  return (
    <React.Fragment>
      {!isErr && (
        <Fragment>
          {(userRole === ROLES.SUPER_ADMIN ||
            userRole === ROLES.NATIONAL_ALGON_ADMIN ||
            userRole === ROLES.NATIONAL_ALGON_COORDINATOR ||
            userRole === ROLES.STATE_ADMIN ||
            userRole === ROLES.STATE_ALGON_CHAIRMAN) && (
            <div className="page-content">
              <Container fluid>
                {/* Render Breadcrumb */}
                <Breadcrumbs
                  title={props.t("Approved Ward Registrar Registration")}
                  breadcrumbItem={props.t(
                    "Approved Ward Registrar Registration"
                  )}
                />

                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by state..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                  />
                </div>

                <Row>
                  {visibleRecords?.map((item, key) => (
                    <Col key={"_col_" + key} md="3">
                      <Card className="mini-stats-wid">
                        <CardBody
                          style={{
                            paddingTop: 40,
                            paddingBottom: 40,
                            paddingLeft: 10,
                            paddingRight: 10,
                          }}
                        >
                          <div className="text-center mb-4">
                            <img
                              src={getItemByName(
                                data,
                                String(item.name).toLowerCase()
                              )}
                              width={100}
                              height={100}
                              style={{ textAlign: "center" }}
                            />

                            <div className="row justify-content-center mt-3">
                              <div className="col-xl-10">
                                <h4 className="text-primary">{item.name}</h4>
                              </div>
                            </div>
                          </div>

                          <hr />
                          <Row
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <Col md="5">
                              <Row>
                                <h5
                                  style={{
                                    textAlign: "center",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    color: "#000",
                                  }}
                                >
                                  Threshold
                                </h5>
                                <h6
                                  style={{
                                    textAlign: "center",
                                    fontSize: "0.9rem",
                                    fontWeight: "500",
                                    color: "#000",
                                  }}
                                >
                                  {item?.threshold.toLocaleString()}
                                </h6>
                              </Row>
                            </Col>
                            <Col md="7">
                              <Row>
                                <h5
                                  style={{
                                    textAlign: "center",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    color: "#000",
                                  }}
                                >
                                  Total Applications
                                </h5>
                                <h6
                                  style={{
                                    textAlign: "center",
                                    fontSize: "0.9rem",
                                    fontWeight: "500",
                                    color: "#000",
                                  }}
                                >
                                  {item?.approvedUserCount.toLocaleString()}
                                </h6>
                              </Row>
                            </Col>
                          </Row>
                          <hr />

                          <Row
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <Col>
                              <h5
                                style={{
                                  textAlign: "center",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  color: "#000",
                                }}
                              >
                                <Link
                                  to={`/approved-agent-registrations-by-lga/${
                                    item?.id
                                  }/${encodeURIComponent(item?.name)}`}
                                >
                                  View LGAs
                                </Link>
                              </h5>
                            </Col>
                            <Col>
                              <h5
                                style={{
                                  textAlign: "center",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  color: "#000",
                                }}
                              >
                                <Link
                                  to={`/view-approved-agent-registrations-by-state/${item?.id}`}
                                >
                                  View Registrars
                                </Link>
                              </h5>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Container>
            </div>
          )}

          {(userRole === ROLES.LGA_FOCAL_PERSON ||
            userRole === ROLES.LGA_CHAIRMAN) && <ViewApprovedAgentsByLga />}
        </Fragment>
      )}

      {isErr && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={errorImg} width={500} />
          <p style={{ marginTop: 5, fontSize: 18 }}>
            Error fetching records...
          </p>
        </div>
      )}
    </React.Fragment>
  )
}

export default withTranslation()(ApprovedAgentRegistrations)
